import { GetSiteInfoReducer } from "./GetSiteInfoReducer";
import { AjaxHandler } from "@npm_leadtech/jsr-lib-http/dist/esm/index";
import { LoggerService } from "../../logger/LoggerService";
import { ErrorHandle } from "../../errors/ErrorHandle";
import { GetSiteInfoAction } from "./GetSiteInfoAction";
import { defaultHeaders } from "../../../config/headers";
import { getApiPrefix } from "../utils";

export class GetSiteInfoHandler extends AjaxHandler {
  /**
   *
   * @param options {Object}
   * @param options.reducer {Class}
   */
  constructor(options) {
    options = options || {};
    super({
      apiPrefix: getApiPrefix(),
      action: GetSiteInfoAction,
      reducer: options.reducer || GetSiteInfoReducer,
      loggerService: LoggerService,
      errorHandler: options.errorHandle || ErrorHandle.default,
      httpParams: {
        authorization: process.env.HTTP_SECRET_KEY,
        headers: {
          ...defaultHeaders(),
        },
      },
    });
  }
}
